/*
 * sign_up / login for classic (non-Hydrogen) Shopify customer accounts.
 *
 * Shopify's `create_customer` and `customer_login` forms are plain POSTs:
 * on success they auto-log-in and redirect away, they never re-render
 * register.json/login.json with a "posted_successfully" state — so there
 * is no Liquid-side hook for "an account/session was just created" the
 * way there is for form errors. The standard workaround (used across most
 * Shopify GA4 integrations, not invented here): compare the logged-in
 * customer id against the last one this browser saw. A new id landing on
 * ANY page (the login modal can redirect back to wherever the shopper
 * was, not just /account) means a session just started; customer.created_at
 * within the last few minutes tells a fresh sign_up apart from a login by
 * a returning customer, since Shopify gives no first-class flag for that
 * distinction either.
 *
 * Never sends the customer id itself to GA4 — only used locally to detect
 * the transition, per the same no-raw-customer-id rule as the server side
 * (services/ga4-events/EVENT-CONTRACT.md).
 */
(function () {
  'use strict';

  function readJSON(id) {
    var node = document.getElementById(id);
    if (!node) return null;
    try {
      return JSON.parse(node.textContent);
    } catch (error) {
      return null;
    }
  }

  function push(eventName, payload) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: eventName }, payload));
  }

  var STORAGE_KEY = 'babalu_customer_session_id';
  var JUST_REGISTERED_WINDOW_SECONDS = 300;

  var data = readJSON('babalu-customer-data');
  var currentId = data && data.id ? String(data.id) : null;
  var previousId = null;
  try {
    previousId = window.localStorage.getItem(STORAGE_KEY);
  } catch (error) {
    previousId = null;
  }

  if (currentId && currentId !== previousId) {
    var ageSeconds = Math.floor(Date.now() / 1000) - Number(data.created_at || 0);
    var justRegistered = data.created_at && ageSeconds >= 0 && ageSeconds < JUST_REGISTERED_WINDOW_SECONDS;
    push(justRegistered ? 'sign_up' : 'login', { method: 'email' });
  }

  try {
    if (currentId) {
      window.localStorage.setItem(STORAGE_KEY, currentId);
    } else {
      window.localStorage.removeItem(STORAGE_KEY);
    }
  } catch (error) {
    // Private browsing or storage disabled: nothing to persist, transition
    // detection just degrades to "fires again next page load" for this
    // visitor, not worth failing louder over.
  }
}());
